<template>
    <v-container>
        <EmployeeForm schema="new"/>
    </v-container>
</template>

<script>
import EmployeeForm from '../../components/Forms/employeeForm.vue';

export default {
    components: { EmployeeForm }
};

</script>